import { useEffect, useState } from 'react';
import {
  Badge,
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react';

import { Pagination } from '../../../../components/_components_0.2/Pagination';
import { ModalViewExpense } from '../../../../components/_components_0.2/Modal/ModalViewExpense';
import {
  IKmEntry,
  KmStatus,
  formatCurrency,
  formatDate,
  formatKm,
  getStatusLabel,
} from './kmData';

const ROWS_PER_PAGE = 15;

const STATUS_COLOR: Record<KmStatus, string> = {
  'EM PROCESSO': 'gray',
  'AGUARDANDO LANCAMENTO': 'yellow',
  LANCADO: 'green',
};

const formatOdometer = (value?: number) =>
  value === undefined ? '—' : value.toLocaleString('pt-BR');

export function KmTable({ entries }: { entries: IKmEntry[] }) {
  const [page, setPage] = useState(1);

  // Volta para a primeira página quando os filtros mudam
  useEffect(() => {
    setPage(1);
  }, [entries]);

  const pageEntries = entries.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE,
  );

  if (entries.length === 0) {
    return (
      <Box py="10" textAlign="center">
        <Text fontSize="sm" color="gray.500">
          Nenhum deslocamento encontrado para os filtros selecionados.
        </Text>
      </Box>
    );
  }

  return (
    <Box>
      <Box overflowX="auto">
        {/* Espaço interno menor para a tabela caber sem barra de rolagem */}
        <Table size="sm" colorScheme="whiteAlpha" sx={{ 'th, td': { px: 2 } }}>
          <Thead>
            <Tr>
              <Th color="gray.400" textAlign="center">
                Ver
              </Th>
              <Th color="gray.400">Data</Th>
              <Th color="gray.400">Usuário</Th>
              <Th color="gray.400">Seção</Th>
              <Th color="gray.400" isNumeric>
                KM inicial
              </Th>
              <Th color="gray.400" isNumeric>
                KM final
              </Th>
              <Th color="gray.400" isNumeric>
                KM percorrido
              </Th>
              <Th color="gray.400">Motivo</Th>
              <Th color="gray.400" isNumeric>
                Valor
              </Th>
              <Th color="gray.400">Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {pageEntries.map(entry => (
              <Tr key={entry.id}>
                <Td textAlign="center">
                  <ModalViewExpense expense={entry.report} readOnly />
                </Td>
                <Td whiteSpace="nowrap">{formatDate(entry.date)}</Td>
                <Td>{entry.userName}</Td>
                <Td>{entry.sectionLabel}</Td>
                <Td isNumeric>{formatOdometer(entry.kmStart)}</Td>
                <Td isNumeric>{formatOdometer(entry.kmEnd)}</Td>
                <Td isNumeric fontWeight="bold" whiteSpace="nowrap">
                  {formatKm(entry.km)}
                </Td>
                <Td maxW="200px">
                  <Tooltip
                    label={entry.reason}
                    hasArrow
                    isDisabled={!entry.reason}
                  >
                    <Text isTruncated>{entry.reason || '—'}</Text>
                  </Tooltip>
                </Td>
                <Td isNumeric whiteSpace="nowrap">
                  {formatCurrency(entry.amount)}
                </Td>
                <Td whiteSpace="nowrap">
                  <Badge
                    colorScheme={STATUS_COLOR[entry.status]}
                    fontSize="2xs"
                  >
                    {getStatusLabel(entry.status)}
                  </Badge>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Pagination
        totalCountOfRegisters={entries.length}
        currentPage={page}
        onPageChange={setPage}
        registersPerPage={ROWS_PER_PAGE}
      />
    </Box>
  );
}
